// extracted by mini-css-extract-plugin
var _1 = "MySharesPage-module__actions___BZd0X";
var _2 = "MySharesPage-module__balanceCell___igZVl";
var _3 = "MySharesPage-module__chart___Jrwga";
var _4 = "MySharesPage-module__currencyName___Ars5G";
var _5 = "MySharesPage-module__expandedRowContent___tHXN_";
var _6 = "MySharesPage-module__expandedRowSection___XA_Xl";
var _7 = "MySharesPage-module__expandedRowSectionTitle___iQlFQ";
var _8 = "MySharesPage-module__header___Ff0vB";
var _9 = "MySharesPage-module__hideOnMobile___ULiP5";
var _a = "MySharesPage-module__table___ai49J";
var _b = "MySharesPage-module__textRightMobile___lzma5";
var _c = "MySharesPage-module__valueInUsd___V4VDv";
export { _1 as "actions", _2 as "balanceCell", _3 as "chart", _4 as "currencyName", _5 as "expandedRowContent", _6 as "expandedRowSection", _7 as "expandedRowSectionTitle", _8 as "header", _9 as "hideOnMobile", _a as "table", _b as "textRightMobile", _c as "valueInUsd" }
